"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// eslint-disable-next-line no-shadow
var STEPS = /*#__PURE__*/function (STEPS) {
  STEPS["FREE_EXTENSION"] = "FREE_EXTENSION";
  STEPS["PAUSE"] = "PAUSE";
  STEPS["DOWNGRADES"] = "DOWNGRADES";
  STEPS["SURVEY"] = "SURVEY";
  STEPS["CONFIRMATION"] = "CONFIRMATION";
  return STEPS;
}(STEPS || {});
var _default = exports.default = STEPS;